import { html } from "@omegagrid/core";
import { NodeModel, TreeOptions } from "@omegagrid/tree";

/**
 * An item of a list shows its key before the label (`key label`), the way the tree select of the v1 application
 * did with the caption "both". The key is left out when it equals the label, and for the headings without a
 * checkbox (the folders of the table and thread trees, the groups of a treelist): their key is not a value
 * the user picks.
 */
export const renderKeyedNode = (_div: HTMLDivElement, node: NodeModel) => {
	const label = node.htmlValue ?? html.escapeHTML(node.value); // htmlValue = the label with the search matches highlighted
	const showKey = node.key && node.key !== node.value && node.checkbox !== false;
	return showKey ? `${html.escapeHTML(node.key)} ${label}` : label;
};

/**
 * Options of a list whose keys mean something to the user (the IDs of the MDM tables, threads and values):
 * the key shows before the label and the search matches the keys too.
 */
export const KEYED_TREE_OPTIONS: Partial<TreeOptions> = {
	searchKeys: true,
	nodeRenderer: renderKeyedNode,
};
